import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { App } from '@/app';
import { SessionProvider } from '@/hooks/use-session';
import { APP_ROOT_ID } from '@/lib/landmarks';
import '@/styles/tokens.css';
import '@/styles/base.css';
import '@/styles/nav.css';
import '@/styles/components.css';
import '@/styles/drawer.css';

const STALE_TIME_MS = 15_000;
const RETRY_COUNT = 1;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: STALE_TIME_MS,
            refetchOnWindowFocus: true,
            retry: RETRY_COUNT,
            throwOnError: true,
        },
    },
});

const container = document.getElementById(APP_ROOT_ID);

if (container === null) {
    throw new Error(`Root element #${APP_ROOT_ID} is missing (1E)`);
}

createRoot(container).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <SessionProvider>
                    <App />
                </SessionProvider>
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>,
);
